export default __webpack_public_path__ + "static/media/laptop-4.74148703.gif";